import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BaseResetPasswordComponent } from 'src/app/shared/components/base-reset-password/base-reset-password.component';

@Component({
  selector: 'app-healthpicks-reset-password',
  templateUrl: './healthpicks-reset-password.component.html',
  styleUrls: ['../style/global.css', '../style/hp-shared.css', './healthpicks-reset-password.component.css'],
})
export class HealthpicksResetPasswordComponent
  extends BaseResetPasswordComponent
  implements OnInit
{
  errorMessageDict = {
    passwordNotInput: 'パスワードを入力してください。',
    confirmPasswordNotInput: '確認用パスワードを入力してください。',
    passwordNotMatch: 'パスワードが一致していません。',
    passwordHistoryError: '別のパスワードを設定してください。（直近3回以内に使用したパスワードは設定できません）',
    weakPasswordError: 'パスワードを確認してください。',
  };

  inputState = {
    password: { isFocus: false, isShow: false },
    confirmPassword: { isFocus: false, isShow: false },
  };

  constructor(title: Title) {
    super();
    title.setTitle('新しいパスワードを設定');
  }

  get serverError(): string {
    const msg = this.errorMessages.confirmPassword;
    if (msg && msg !== this.errorMessageDict.confirmPasswordNotInput && msg !== this.errorMessageDict.passwordNotMatch) {
      return msg;
    }
    return '';
  }

  get confirmError(): string {
    const msg = this.errorMessages.confirmPassword;
    if (msg === this.errorMessageDict.confirmPasswordNotInput || msg === this.errorMessageDict.passwordNotMatch) {
      return msg;
    }
    return '';
  }

  ngOnInit(): void {}

  async submitChangePassword() {
    await super.submitChangePassword();
    // TODO: base の `dict` (private const) が返す日本語文字列との完全一致に依存しているため、
    //       base 側の文言変更でサイレントに無効化される。
    //       将来的には base の `dict` を export する／`error.name` ベースのフックを base に生やす
    //       などの方法で文字列比較を解消する。
    if (this.errorMessages.confirmPassword === 'このパスワードは以前使用されています。') {
      this.errorMessages.confirmPassword = this.errorMessageDict.passwordHistoryError;
    } else if (this.errorMessages.confirmPassword === '半角英数字と記号を3種類以上含めた、8文字以上のパスワードを入力してください') {
      this.errorMessages.confirmPassword = this.errorMessageDict.weakPasswordError;
    }
  }
}
